// Environment-specific configuration
//
// The survey API is shared by every rec tool (Cavs United, Monsters, In-Game,
// Charge, WNBA). Per-survey routing is done by the `campaign` field in the
// request body, NOT by the URL path — there are only three base paths:
// /survey-dev, /survey-test and /survey.
//
// API keys are hardcoded per environment rather than injected at build time:
// the deploy workflow only provides VITE_API_ENDPOINT + VITE_APP_ENV, and a
// static SPA ships its key in the bundle either way. This matches the pattern
// used by the sibling survey frontends.

const environments = {
  dev: {
    apiEndpoint: 'https://api1.cavs.com/survey-dev',
    apiKey: '49jg09j9asjhshij3aqjgmsrD',
    environment: 'development'
  },
  test: {
    apiEndpoint: 'https://api1.cavs.com/survey-test',
    apiKey: '49jg09j9asjhshij3aqjgmsrT',
    environment: 'test'
  },
  prod: {
    apiEndpoint: 'https://api1.cavs.com/survey',
    apiKey: '49jg09j9asjhshij3aqjgmsrP',
    environment: 'production'
  }
};

// The deploy workflow builds with `--mode dev|test|prod` and writes VITE_APP_ENV.
const env = import.meta.env?.VITE_APP_ENV || import.meta.env?.MODE || 'dev';
const selected = environments[env] || environments.dev;

// A build-injected endpoint wins, so the workflow stays the single source of
// truth for which stage a deploy points at. Trailing slashes are stripped —
// api.js adds the separator.
const apiEndpoint = (import.meta.env?.VITE_API_ENDPOINT || selected.apiEndpoint).replace(/\/$/, '');

const config = {
  apiEndpoint,
  apiKey: selected.apiKey,
  ga4MeasurementId: import.meta.env?.VITE_GA4_MEASUREMENT_ID || null,
  environment: selected.environment,
  seatGeekUrl: 'https://seatgeek.com/wnba-cleveland-tickets/wnba/2028-01-01-3-30-am/17383484',
  campaign: 'WNBA CLE Recommendations'
};

export default config;
